import Pattern from "../../assets/HeadingSectionPattern.svg"

const BlogHeroSection = () => {
    return (
        <div className="bg-[#c7461f] relative md:h-[435px] sm:h-[400px] h-[360px] md:mt-20 mt-[60px]">
            <img src={Pattern} className="absolute w-full h-full md:object-cover" alt="" />
            <div className="container z-50 relative h-full flex items-center justify-center ">
                <div className="w-full text-white text-center">
                    <h1 className="font-semibold lg:text-5xl md:text-4xl sm:text-3xl text-2xl mb-1.5">
                        News and blogs
                    </h1>
                    <p className="mb-8 md:text-lg sm:text-base text-sm max-w-4xl mx-auto">
                        Omnis dignissimos facere. Omnis suscipit rem quo praesentium omnis sit. Ea aut quasi ea ratione consequatur consequatur. Pariatur alias ab tenetur eum qui tempore eos et. Cum omnis veritatis in quis ipsa consequuntur.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default BlogHeroSection